import AdminHeader from "app/frontend/components/static/admin/AdminHeader";
import dayjs from "dayjs";
import React, { PropsWithChildren } from "react";

import { ROUTES } from "app/frontend/constants/routes";
import advancedFormat from "dayjs/plugin/advancedFormat";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

const PAGES: powerready.layout.IAdminHeaderPages = {
  ADMIN: [
    {
      name: <span>Banner Events</span>,
      routes: {
        main: ROUTES.PowerReady.Admin.Banners,
      },
    },
    {
      name: <span>Incentives Data</span>,
      routes: {
        main: ROUTES.PowerReady.Admin.Incentives,
      },
    },
    {
      name: <span>Contractors</span>,
      routes: {
        main: ROUTES.PowerReady.Admin.ContractorEdit(1),
      },
    },
    {
      name: <span>Settings</span>,
      routes: {
        main: ROUTES.PowerReady.Admin.Admins,
      },
    },
    {
      name: <span>Contact Submissions</span>,
      routes: {
        main: ROUTES.PowerReady.Admin.ContactSubmissions.INDEX,
      },
    },
  ],
  BD: [],
};

const AdminLayout: React.FC<PropsWithChildren & Record<string, any>> = ({
  children,
  header_type,
  ...props
}) => {
  return (
    <>
      <AdminHeader
        pages={PAGES}
        headerType={header_type}
        role={props.current_admin_role}
      />

      {React.Children.map(children, (child) =>
        React.isValidElement(child)
          ? React.cloneElement(child, {
              ...(child?.props ?? {}),
              ...props,
            })
          : child,
      )}
    </>
  );
};

const Layout = (page: React.JSX.Element) => (
  <AdminLayout {...page.props}>{page}</AdminLayout>
);

export default Layout;
